import BasePage from '../../components/base-page/base-page';
import InstallerDownloadBalloon from '../../components/installer-download-balloon/installer-download-balloon';
import './download.scss';

const DOWNLOAD_TIMEOUT = 3000;
const DISAPPEAR_TIMEOUT = 6000;

class DownloadPage extends BasePage {
  ui = {
    downloadLink: '.js-download-link',
  };

  events = {
    'click @ui.downloadLink': 'onDownloadInstallerLinkClick',
  };

  onInit() {
    super.onInit();

    this.downloadBalloon = new InstallerDownloadBalloon();
    this.downloadBalloon.init();
  }

  onDownloadInstallerLinkClick(event) {
    event.preventDefault();
    setTimeout(() => {
      this.downloadBalloon.show();

      setTimeout(() => {
        this.downloadBalloon.hide();
      }, DISAPPEAR_TIMEOUT);
    }, DOWNLOAD_TIMEOUT);

    window.location.assign(event.currentTarget.href);
  }
}

export default DownloadPage;
DownloadPage.initOnDomLoaded();
